import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointDetails } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { meteringPointSubtypePartial } from "@root/app/shared/partials/meteringpointsubtype.partial";
import { physicalStatusPartial } from "@root/app/shared/partials/physicalstatus.partial";
import { meteringPointTypePartial } from "@root/app/shared/partials/meteringpointtype-partial.table";
import { disconnectionTypePartial } from "@root/app/shared/partials/disconnectiontype.partial";
import {
  productCharacteristicIdentificationPartial
} from "@root/app/shared/partials/productcharacteristicidentification.partial";
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { unitTypePartial } from '@shared/partials/unit-type.partial';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { netSettlementGroupPartial } from '@shared/columns/meteringpoint.columns';
import { assettypePartial } from '@shared/partials/assettype.partial';
import { connectiontypePartial } from '@shared/partials/connectiontype.partial';
import { DefaultToCellComponent } from '@shared/components/table/cells/default-to-cell/default-to-cell.component';

export const meteringPointMasterData: Columns<MeteringPointDetails>[] = [
  {
    title: 'Målepunkts ID',
    key: 'identification'
  },
  {
    title: 'meteringPoint.details.parentID',
    key: 'parentMeteringPointIdentification',
    cellRenderer: LinkCellComponent,
    cellRendererParams: {
      url: '/meteringpoint',
      urlReference: 'parentMeteringPointIdentification'
    }
  },
  {
    title: 'connectionpoint.title',
    key: 'connectionPointIdentification',
    cellRenderer: LinkCellComponent,
    cellRendererParams: {
      url: '/connectionpoint',
      urlReference: 'connectionPointIdentification'
    }
  },
  {
    ...datahubPartial as Columns<MeteringPointDetails>
  },
  {
    title: 'common.date.validfrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent
  },
  {
    ...meteringPointTypePartial,
    key: 'detailCharacteristics.meteringPointType'
  },
  {
    ...meteringPointSubtypePartial,
    key: 'detailCharacteristics.subType'
  },
  {
    ...physicalStatusPartial,
    key: 'detailCharacteristics.physicalStatus'
  },
  {
    ...disconnectionTypePartial,
    key: 'detailCharacteristics.disconnectionType'
  },
  {
    ...connectiontypePartial,
    key: 'detailCharacteristics.connectionType'
  },
  {
    title: 'meteringPoint.details.gridArea',
    key: 'detailCharacteristics.gridArea.name'
  },
  {
    title: 'meteringPoint.details.fromGrid',
    key: 'detailCharacteristics.fromGridName',
    hideIfNull: true
  },
  {
    title: 'meteringPoint.details.toGrid',
    key: 'detailCharacteristics.toGridName',
    hideIfNull: true
  },
  {
    ...netSettlementGroupPartial,
    key: 'detailCharacteristics.netSettlementGroup'
  },
  {
    title: 'meteringPoint.details.gsrn',
    key: 'detailCharacteristics.powerPlantIdentification'
  },
  {
    ...unitTypePartial,
    key: 'detailCharacteristics.productCharacteristicUnitType'
  },
  {
    ...assettypePartial,
    key: 'detailCharacteristics.assetType'
  },
  {
    title: 'meteringPoint.create.capacity',
    key: 'detailCharacteristics.capacity'
  },
  {
    ...productCharacteristicIdentificationPartial,
    key: 'detailCharacteristics.productCharacteristicIdentification'
  },
  {
    title: 'meteringPoint.create.maximumPower',
    key: 'detailCharacteristics.maximumPower',
    cellRenderer: DefaultToCellComponent,
    cellRendererParams: {
      defaultTo: '0'
    }
  },
  {
    title: 'meteringPoint.create.maximumCurrent',
    key: 'detailCharacteristics.maximumCurrent',
    cellRenderer: DefaultToCellComponent,
    cellRendererParams: {
      defaultTo: '0'
    }
  },
  {
    title: 'actor.businessrole.balancepowersupplier',
    key: 'detailMeteringPointPartyCharacteristic.hasBalanceSupplier',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      0: { color: 'bg-red-500', label: 'common.no' },
      1: { color: 'bg-green-500', label: 'common.yes' }
    }
  },
  {
    title: 'meteringPoint.create.electricalHeating',
    key: 'detailMeteringPointPartyCharacteristic.electricalHeating',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      0: { color: 'bg-red-500', label: 'common.no' },
      1: { color: 'bg-green-500', label: 'common.yes' }
    }
  }
];
